<template>
    <div class="textarea-container">
        <textarea
            :class="cssClass"
            :id="id"
            ref="input"
            :value="value"
            :rows="rows"
            :placeholder="placeholder"
            :maxlength="maxlength"
            @keypress="event => this.$emit('keypress', event)"
            @input="onInput"
            @blur="onBlur"
        >
        </textarea>
        <template v-if="showCharacterCount">
            <span class="character-count">{{ characterCount }}</span>
        </template>
    </div>
</template>

<script>
export default {

    name: 'InputTextarea',

    props: {
        value: '',
        id: {
            type: String,
            default: () => { return 'input-' + Math.floor(Math.random() * 1000000000); }
        },
        isBootstrap: {
            type: Boolean,
            default: false
        },
        isBulma: {
            type: Boolean,
            default: true
        },
        inputSize: {
            type: String,
            default: ''
        },
        showCharacterCount: {
            type: Boolean,
            value: true
        },
        maxlength: Number,
        rows: {
            type: String,
            default: '2'
        },
        placeholder: String,
    },

    computed: {
        cssClass() {
            const classes = [];
            if(this.isBootstrap) {
                classes.push('form-control')
                if(this.inputSize) {
                    classes.push('input-' + this.inputSize)
                }
            }

            if (this.isBulma) {
                classes.push('textarea')
                if(this.inputSize) {
                    classes.push('is-' + this.inputSize)
                }
            }

            return classes.join(' ');
        },

        characterCount() {
            if(this.value != null) {
                return parseInt(this.maxlength) - this.value.length;
            } else {
                return parseInt(this.maxlength);
            }
        },
    },

    methods: {
        setFocus() {
            this.$refs.input.focus()
        },
        onInput(event) {
            this.$emit('input', event.target.value);
        },
        onBlur(event) {
            this.$emit('blur', event.target.value)
        },
    },
}
</script>

<style scoped>
.textarea-container {
    position: relative;
}
.character-count {
    position: absolute;
    right: 5px;
    bottom: 3px;
}
</style>
